<ng-container  *transloco="let convert;">
  <div class="advanced_search_trim__arrow"></div>
  <div class="advanced_search_trim" (click)="onClick($event)" >
    <div [hidden]="!showDropdown">
      {{convert('sellModule.manageInventory.advancedSearch.advancedSearchTrim.titleSearchTrim')}}
    </div>

    <div [hidden]="showDropdown" >
      <div class="form-group advanced_search_trim--search">
        <label for="search">{{convert('common.labelSearch')}}</label>
        <div class="control-wrapper">
          <input name="search" id="search" class="form-control" (input)="onInput($event)" maxlength="30" />
        </div>
      </div>

      <div class="advanced_search_trim--accordion">
        <accordion class="ui-accordion" style="border-style: none;">
          @for (item of flattenedTrimOptions; track item) {
            <accordion-group
              [isOpen]="item.isOpen && !collapseAll"
              [heading]="item.vehicleMake +' '+ item.vehicleModel"
              (isOpenChange)="item.isOpen = toggleOpenChange($event)"
              >
              @if (item.isOpen) {
                <div class="form-group">
                  <div class="control-wrapper">
                    @for (trim of getAlphabeticalTrims(item.vehicleTrims); track trim) {
                      <div
                        class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
                        >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          [id]="getInputId(item, trim)"
                          [checked]="checked(item, trim)"
                          (change)="selectTrim(item, trim)" />
                        <label
                          class="custom-control-label"
                          [for]="getInputId(item, trim)">
                          {{ trim }}
                        </label>
                      </div>
                    }
                  </div>
                </div>
              }
            </accordion-group>
          }
        </accordion>
      </div>

      <div class="advanced_search_trim--action_btn">
        <button
          class="btn btn-secondary advanced_search_trim--action_btn__close"
          [attr.aria-label]="convert('common.btnClose')"
          type="button"
          (click)="close()"
          >
          {{convert('common.btnClose')}}
        </button>
      </div>
    </div>
  </div>
</ng-container>
